<template>
    <div>
        <van-nav-bar title="公益项目" />
        <div style="padding: 12px;">
            <img src="/static/charity.png" style="width: 100%; border-radius: 8px;" />
        </div>
    </div>
</template>
<script>
import { NavBar } from 'vant';

export default {
    name: 'Charity'
}
</script>


// WEBPACK FOOTER //
// src/components/Charity.vue